import { QueryTable } from '@app/components/common/table';
import { useApi, useFetchData } from '@app/hooks';

import { useColumns } from './columns';

export const SessionsTable = () => {
  const api = useApi();
  const [fetchData] = useFetchData({
    method: api.socket.getSessions
  });

  const columns = useColumns();

  return <>
    <QueryTable
      title="Сессии SNEG-Delivery"
      columns={columns}
      fetchData={fetchData}
      canDownload
    />
  </>;
};